import { render, staticRenderFns } from "./TagMultiselect.vue?vue&type=template&id=51b8b86d&"
import script from "./TagMultiselect.vue?vue&type=script&lang=js&"
export * from "./TagMultiselect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports